<template>
  <svg 
    :width="size" 
    :height="size" 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect 
      x="2" 
      y="5" 
      width="20" 
      height="14" 
      rx="2" 
      :stroke="color" 
      stroke-width="1.5"
    />
    <path 
      d="M2 10H22" 
      :stroke="color" 
      stroke-width="1.5"
    />
    <path 
      d="M6 15H10" 
      :stroke="color" 
      stroke-width="1.5" 
      stroke-linecap="round"
    />
  </svg>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  size?: number | string
  color?: string
}>(), {
  size: 24,
  color: 'currentColor',
})
</script>

